import type { MbcAdminGuideline } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { listGuidelines } from "../api";

export function useGuidelines(): UseQueryResult<MbcAdminGuideline[], Error> {
  return useQuery({
    queryFn: listGuidelines,
    queryKey: mbcAdminKeys.guidelines(),
  });
}
